import { is } from 'ramda'

export const isString = is(String)
